import { Injectable } from '@angular/core';
import { ApiResponse } from '@src/app/core/models/api-response.model';
import { BranchUnderHQ } from '@src/app/core/models/branch-under-hq';
import { DealerInformation } from '@src/app/core/models/dealer-information.model';
import { DealerSales } from '@src/app/core/models/dealer-sales.model';
import { Dealer } from '@src/app/core/models/dealer.model';
import { ApiWebSubmissionService } from '@src/app/core/services/api-web-submission.service';
import { Observable } from 'rxjs';
import { DealerEmailPhone } from '../models/dealer-email-phone.model';
import { DealerRating } from '../models/dealer-rating.model';
import { DealerStatus } from '../models/dealer-status.model';

@Injectable()
export class ApiDealerService {
  constructor(private apiWebSubmissionService: ApiWebSubmissionService) {}

  getDealer(companyId: string): Observable<ApiResponse<{ data: Dealer[] }>> {
    return this.apiWebSubmissionService.doPost(
      '/Dealer/DealerSearch',
      {
        page: 1,
        limit: 10000,
        dealerCode: 'All',
        dealerName: 'All',
        sortModel: [],
        queryAll: true,
      },
      { 'X-CompanyId': companyId || '' }
    );
  }

  getDealerSales(dealerCode: string): Observable<ApiResponse<DealerSales[]>> {
    return this.apiWebSubmissionService.doGet(
      `/Dealer/GetDealerSales/${dealerCode}`
    );
  }

  /** 取得供應商資訊 */
  getDealerInformation(
    companyId: string,
    dealerCode: string
  ): Observable<ApiResponse<DealerInformation>> {
    return this.apiWebSubmissionService.doPost(
      `/Dealer/GetDealerInformation`,
      { dealerCode },
      {
        'X-CompanyId': companyId.toString(),
      }
    );
  }

  /** 查詢母公司下的子公司 */
  getQueryBranchUnderHQ(
    companyId: string,
    dealerCode: string
  ): Observable<ApiResponse<BranchUnderHQ[]>> {
    return this.apiWebSubmissionService.doPost(
      '/Dealer/QueryBranchUnderHQ',
      { dealerCode },
      { 'X-CompanyId': companyId }
    );
  }

  /** 取得供應商的Sales名單 - 多筆 */
  getDealerSalesList(companyId: string, dealerCode: string[]): Observable<ApiResponse<DealerSales[]>>{
    return this.apiWebSubmissionService.doPost(
      '/Dealer/GetDealerSalesList',
      dealerCode,
      { 'X-CompanyId': companyId }
    );
  }

  getDealerUserByAuthorizedCode(authorizedCode: string): Observable<ApiResponse<DealerStatus>> {
    return this.apiWebSubmissionService.doGet(
      `/Dealer/getDealerUserByAuthorizedCode/${authorizedCode}`
    );
  }

  getDealerRating(): Observable<ApiResponse<DealerRating>> {
    return this.apiWebSubmissionService.doGet(
      '/Dealer/GetDealerRating'
    );
  }

  checkDealer(authorizedCode: string): Observable<ApiResponse<DealerEmailPhone>> {
    return this.apiWebSubmissionService.doPost(
      `/Dealer/CheckDealer/${authorizedCode}`
    );
  }

  
}
